import { invalidateProductStock } from './productThreshold'

// A stock movement changes lists, item details and both dashboard alert views.
export function invalidateInventoryMovement(queryClient) {
  return Promise.all([
    invalidateProductStock(queryClient),
    ...[
      'movimenti-magazzino', 'movimenti-recenti', 'movimenti-flussi',
      'giacenze-componenti', 'giacenze-componenti-sottoscorta',
      'giacenza-componente', 'componenti', 'componente',
      'giacenze-box', 'tipologie-box',
    ].map((key) => queryClient.invalidateQueries({ queryKey: [key], refetchType: 'all' })),
  ])
}
